import { useStoreActions } from '~/contexts';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { QueryKeys } from '../queryKeys';
export const EMPTY_CLIENT_CONTACTS = [];
export const useClientContacts = function useClientContacts(clientId) {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.ClientContacts,
            clientId
        ],
        queryFn: ()=>clientId == null ? Promise.resolve(EMPTY_CLIENT_CONTACTS) : api.client.getContacts(clientId),
        enabled: enabled && clientId != null,
        refreshOnHookMount,
        keepPreviousData: false
    });
    return {
        contacts: data !== null && data !== void 0 ? data : EMPTY_CLIENT_CONTACTS,
        isLoading,
        error,
        refresh
    };
};
